import React from "react";

export const ScrollingNews = () => {
  return (
    <div className="scrolling__news__wrapper">
      <div className="label">Announcement</div>
      <div className="text__wrapper">
        {/* <p>
          New admission started for computer courses. Paramedical and technical
          courses also. All classes are conducted adhering to the COVID – 19
          regulations. For more details contact 9447183114.
        </p> */}
        <p>
         Admission started for Computer Courses, General Duty Assistant, Hospital Administration.
For more information contact: <b>9061098914 </b>
        </p>
      </div>
    </div>
  );
};
